/**
 * ConfidentialityAgreement Component
 * 
 * Renders a confidentiality agreement disclaimer for GEICO agency onboarding.
 * This component displays the legal terms and conditions that independent agency
 * employees or contractors must acknowledge before accessing GEICO's Information Systems.
 * 
 * @component
 * @returns {JSX.Element} A gds-disclaimer element containing the confidentiality agreement text
 * 
 * @example
 * // Basic usage in a review and sign flow
 * <ConfidentialityAgreement />
 */
export default function ConfidentialityAgreement() {
    return (
        <gds-disclaimer data-onboarding-control-id="shared:ReviewAndSign:ConfidentialityAgreement:ConfidentialityAgreement" expanded="true" accordion-style="">
            Confidentiality Agreement
            <div slot="content">
                You have requested access to GEICO's Information Systems (as that term is defined in the Information Security Policy) as
                an employee or contractor of an independent agency. Your agency's contract with GEICO incorporates GEICO's Security and Privacy Addendum.
                You acknowledge that your agency has provided you GEICO's Security and Privacy Addendum or otherwise advised you of its contents,
                and you agree to abide by its terms. By accessing GEICO's Information Systems, you will have exposure to GEICO's Confidential Information
                (as that term is defined in the contract between your agency and GEICO). You acknowledge that your agency has advised you of its obligations
                with respect to GEICO's Confidential Information and you agree to fulfill those obligations. You agree that you will access GEICO's Information
                Systems, and use GEICO's Confidential Information for the sole and limited purpose of selling and servicing GEICO products and services and for
                no other purpose. Access to GEICO's Information Systems is granted by GEICO in its sole and absolute discretion. GEICO may suspend or revoke
                your access to its Information systems at any time and for any reason including, but not limited to i) any actual or suspected failure to adhere to
                the GEICO Security and Privacy Addendum; ii) any actual or suspected failure to adhere to the terms of the contract between your agency and GEICO; or
                iii) a suspension or revocation of your insurance license. GEICO Security and Privacy Addendum was written for a broad audience of users, any
                incidental references therein to "employer", "employee", "associate" or such similar terms are for reference only and shall have no impact on the
                independent contractor nature of the relationship your agency and GEICO, nor is it intended to create an employment relationship between yourself and GEICO.
            </div>
        </gds-disclaimer>
    );
}
